import { connect } from "react-redux"
import FullBleedImageWidget from "QuorumGrassroots/widgets/FullBleedImage/components/index"
import { fullWidthWidgetConnection } from "QuorumGrassroots/widgets/selectors"

export default connect(fullWidthWidgetConnection, null)(FullBleedImageWidget)
